import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AddressMrhComponent } from "@shared/components/offers/MRH/address-mrh/address-mrh.component";
import { TitlePjComponent } from "@shared/components/offers/PJ/title-pj/title-pj.component";
import { TitleSaComponent } from "@shared/components/offers/SA/title-sa/title-sa.component";
import { StatusCardComponent } from "@shared/components/status-card/status-card.component";
import { SvgIconComponent } from "@shared/components/svg-icons/svg-icons.component";
import { ID_PARAM } from "@shared/constants/route-variables.constants";
import { QUOTATIONDETAILS } from "@shared/constants/route.constants";
import { Branches } from "@shared/enums/branches";
import { Quotation } from "@shared/models/quotation";
import { StatusConfig } from "@shared/models/status-config.model";
import { OffersTypeService } from "@shared/services/offers-type.service";
import { QuotationStatusService } from "@shared/services/quotation-status.service";
import { QuotationService } from "@shared/services/quotation.service";
import { Guid } from "guid-typescript";
import { AccordionModule } from "primeng/accordion";
import { ButtonModule } from "primeng/button";
import { QuotationCardComponent } from "./quotation-card/quotation-card.component";

@Component({
  selector: "app-quotation",
  standalone: true,
  imports: [
    CommonModule,
    AccordionModule,
    ButtonModule,
    TranslateModule,
    QuotationCardComponent,
    AddressMrhComponent,
    StatusCardComponent,
    SvgIconComponent,
    TitlePjComponent,
    TitleSaComponent
  ],
  templateUrl: "./quotation.component.html",
  styleUrls: ["./quotation.component.scss"],
})
export class QuotationComponent implements OnInit {
  @Input() quotations: Quotation[] = [];

  activeIndex: number | null = 0;
  quotationStatusConfig!: Record<string, StatusConfig>;

  branches = Branches;

  constructor(
    private readonly quotationStatusService: QuotationStatusService,
    private readonly router: Router,
    private readonly offersTypeService: OffersTypeService,
    private readonly quotationService: QuotationService
  ) {}

  ngOnInit() {
    this.quotationStatusConfig = this.quotationStatusService.getStatusConfig();
    this.quotations.length === 0 ? (this.activeIndex = 0) : (this.activeIndex = null);
  }

  formatDateString(dateString: string | null): string {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR");
  }

  navigateToDetails(id: Guid) {
    const url = QUOTATIONDETAILS.replace(ID_PARAM, id.toString());
    this.router.navigate([url]);
  }
  onKeyDown(event: KeyboardEvent, id: Guid) {
    if (event.key === "Enter" || event.key === " ") {
      this.navigateToDetails(id);
    }
  }

  isBranchMrh(quotation: Quotation): boolean {
    return this.offersTypeService.isQuotationBranch(quotation, Branches.MRH);
  }

  isBranchPJ(quotation: Quotation): boolean {
    return this.offersTypeService.isQuotationBranch(quotation, Branches.PJ);
  }

  isBranchSA(quotation: Quotation): boolean {
    return this.offersTypeService.isQuotationBranch(quotation, Branches.SA);
  }
  getCustomStatus(quotation: Quotation): string {
    return this.quotationService.getCustomStatus(quotation);
  }
}
